import { getLang } from "./themeHelpers";
import {
  CATEGORIES_WITH_RECOMMENDED_TYPE_2,
  CATEGORIES_WITH_SIMILAR_TYPE_2,
  CookiesConstants,
  CustomThemeConstants
} from "utils/constants";
import { EnumOrderMode } from "../enums/EnumOrderMode";
import { parseCookies } from "utils/nookies";
import { jsonSafeGet } from "utils/Helpers";
import { LiteUserInfo } from "dataLayer/localStorage/localStorageMember";

interface IReplaceWithParams {
  textToReplace: string;
  textToRelpaceWith: string;
  fullString: string;
}

type IThemeCustomConstants =
    | "logoDesktop"
    | "logoMobile"
    | "logoSquare"
    | "page404"
    | "chooseCountryPage"
    | "opensooqLogoPage"
    | "showTopBanner"
    | "palestineRadiosPage"
    | "currencyRatesPage"
    | "daleelsPage"
    | "mediclesPage"
    | "craftsPage"
    | "universitiesPage"
    | "vaccinationsPage"
    | "palestinianUniversitiesPage"
    | "gradesPage"
    | "chatService"
    | "AdServices"
    | "adTheme"
    | "domainTheme"
    | "favIcon"
    | "splashScreen"
    | "noImage_ar"
    | "noImage_en";

export const replaceWith = ({
  textToReplace,
  textToRelpaceWith,
  fullString,
}: IReplaceWithParams) => fullString.replace(textToReplace, textToRelpaceWith);

export const isCategoryRealEstate = (
  category: Required<{ reporting_name: string }>
) => {
  return (
    category?.reporting_name === "RealEstateForSale" ||
    category?.reporting_name === "RealEstateForRent" ||
    category?.reporting_name === "RealEstate"
  );
};

export const isCategoryService = (
  category: Required<{ reporting_name: string }>
) => {
  return category?.reporting_name === "Services";
};

export const isCategoryCars = (
  category: Required<{ reporting_name: string }>
) => {
  return category?.reporting_name === "Autos";
};

export const isCategoryVipMobileNumbers = (
  subCategory: Required<{ reporting_name: string }>
) => {
  return subCategory?.reporting_name === "SpecialPhoneNumbers";
};

export const isSimilarAdsType2 = (
  category: Required<{ reporting_name: string }>
) => {
  return CATEGORIES_WITH_SIMILAR_TYPE_2.includes(category?.reporting_name);
};
export const isRecommendedAdsType2 = (
  category: Required<{ reporting_name: string }>
) => {
  return CATEGORIES_WITH_RECOMMENDED_TYPE_2.includes(category?.reporting_name);
};
export const getCurrentOrderMode = (
  orderModes: any,
  currentOrder: string | string[]
) => {
  return orderModes.filter((item) => {
    return item?.orderMode?.toString() === currentOrder?.toString();
  });
};
export const formatMyOsLink = ({
  uri,
  protocol,
  domain,
}: {
  uri: string;
  protocol: string;
  domain: string;
}) => {
  let dominWithoutCountry = domain?.includes("localhost")
    ? "sooqtest.com"
    : domain?.slice(3);
  return `${protocol}://my.${dominWithoutCountry}${uri}`;
};
export const getDefaultOrderModes = (lang: string = null) => {
  const locale = lang || getLang();
  const defaultSortCases = [
    {
      label: locale === "ar" ? "الاكثر تطابقا" : "Relevant",
      solrField: null,
      orderMode: EnumOrderMode.MOST_RELEVANT,
    },
    {
      label: locale === "ar" ? "التاريخ: الأحدث" : "Date: Newest",
      solrField: null,
      orderMode: EnumOrderMode.NEWEST,
    },
    {
      label: locale === "ar" ? "السعر: الأعلى" : "Price : Descending",
      solrField: null,
      orderMode: EnumOrderMode.HIGHEST_PRICE,
    },
    {
      label: locale === "ar" ? "السعر: الأدنى" : "Price : Ascending",
      solrField: null,
      orderMode: EnumOrderMode.LOWEST_PRICE,
    },
  ];

  return defaultSortCases;
};
export const prepareImageUrl = (img: string, size: string = "xxh"): string => {
  return img.replace("{platform}", "android").replace("{size}", size);
};

export const isLoggedInMember = () => {
  const cookies = parseCookies();
  const userInfo = jsonSafeGet<LiteUserInfo>(
    cookies[CookiesConstants.USER_INFO]
  );
  return !!userInfo?.id;
};
export const isJobSeeker = (
    subcategory: Required<{ reporting_name: string }>
) => {
  return subcategory?.reporting_name === "JobSeeker";
};

export const getCustomThemeValue = (key: IThemeCustomConstants) => {
  if (isShobiddak()) {
    return CustomThemeConstants.shobiddak[key] ;
  }
  return CustomThemeConstants.default[key] ;
};

export const isChatEnabledPerCountry = (country:string) => {
  const notAllowedCountryCodesRegex = new RegExp(`^(${process.env.NEXT_PUBLIC_CHAT_NOT_ALLOWED_COUNTRY_CODES})`);
  return !notAllowedCountryCodesRegex.test(country);
};

export const isChatEnabled = (country) => {
  return process.env.NEXT_PUBLIC_CUSTOM_THEME ? getCustomThemeValue("chatService") : isChatEnabledPerCountry(country);
};

export const isShobiddak = () => {
  return process.env.NEXT_PUBLIC_CUSTOM_THEME == 'shobiddak'
}

export const maskPhone = (phone) => {
  const regex = /\d{2}$/;
  return phone.replace(regex, 'XX');
}
